module.exports = {
  siteTitle:
    'Gain visibility. Remove blockers. Ship 10x faster.',
  googleTagManagerId: 'GTM-WWLSQCV'
}
